<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Order Statistic">
    <template v-slot:body>
      <TableList :config="config()"></TableList>
    </template>
  </Body>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import TableList from './TableList.vue'
export default {
  components: {
    Header,
    SideBar,
    Body,
    TableList
  },
  methods: {
    config() {
      return {
        showTableFilters: true,
        preload: true,
        tableId: 'order-statistic-detail',
        indexUri: 'order/statistic-detail',
        storeId: ['main']
      }
    }
  }
}
</script>
<style lang="scss">
.page-order-statistic-detail {
  .tablenav {
    input {
      max-width: 170px;
    }
  }
  .table-container > .main-card .card-body {
    min-width: 1000px;
  }
  .multiselect {
    width: 170px;
  }
  .filter-form {
    .dp__outer_menu_wrap {
      left: 0 !important;
    }
  }
}
</style>
